import Spinner from "@/components/ui/Spinner";

export function DashboardLoadingState() {
  return (
    <div className="flex min-h-[320px] items-center justify-center rounded-lg border border-slate-200 bg-white shadow-sm">
      <div className="flex items-center gap-3 text-sm font-semibold text-slate-600">
        <Spinner size="md" variant="primary" label="Loading dashboard" />
        Loading dashboard...
      </div>
    </div>
  );
}
